import { useEffect,useLayoutEffect,useState } from "react";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Product from "../components/Product";

export default function ProductPage() {
    const [loading, setLoading] = useState(true);
  
    const navigate = useNavigate();

    useEffect(()=>{
        const userString = sessionStorage.getItem("user");
        setLoading(false)
       if(!userString){
        navigate('/login')
       }
    },[])
    return(
        <Spin spinning={loading} size="large">
        <div className="homeWrapper">
             <Header />
             <div className="rightContainer" id="rightContainer">
                <p className="heading">CG NET <span>Knowledge Base System</span></p>
                <Product />
                <Footer />
             </div>
        </div>
        </Spin>
    )
}